<script setup lang="ts">
import { ModalDefault, ModalView } from '@shared/ui/modals'
import { InputPrimary } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalCustomerCredits } from '../../model/credits/modal-customer-credits.hook'

defineOptions({
  name: 'ModalCustomerCredits',
})

const {
  refIsOpen,
  refIsProcessing,
  refAdjustment,
  refAmount,
  isSubmitDisabled,
  setAdjustment,
  setAmount,
  close,
  submit,
} = useModalCustomerCredits()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsProcessing"
    :view="ModalView.Tabs"
    title="Edit credits"
    @click:overlay="close"
  >
    <div class="modal-customer-credits">
      <div
        class="modal-customer-credits__tabs"
        role="tablist"
      >
        <button
          type="button"
          role="tab"
          :aria-selected="refAdjustment === 'add'"
          :class="['modal-customer-credits__tab', { selected: refAdjustment === 'add' }]"
          @click="setAdjustment('add')"
        >
          Top up balance
        </button>
        <button
          type="button"
          role="tab"
          :aria-selected="refAdjustment === 'remove'"
          :class="['modal-customer-credits__tab', { selected: refAdjustment === 'remove' }]"
          @click="setAdjustment('remove')"
        >
          Remove from balance
        </button>
      </div>
      <InputPrimary
        type="number"
        name="credits_amount"
        label="Amount, $"
        placeholder="Type here"
        step="0.01"
        :min="0"
        :value="refAmount"
        :disabled="refIsProcessing"
        required
        @update:value="setAmount"
      />
    </div>

    <template #controls>
      <BtnPrimary
        v-if="refAdjustment === 'add'"
        text="Add to balance"
        color="emerald"
        :disabled="isSubmitDisabled"
        @click="submit"
      />
      <BtnPrimary
        v-else
        text="Remove from balance"
        color="red"
        :disabled="isSubmitDisabled"
        @click="submit"
      />
      <BtnSecondary
        text="Cancel"
        :disabled="refIsProcessing"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCustomerCredits.scss" />
